@let collapsed = isCollapsed();
<div class="sidebar__logo">
  <a
    class="sidebar__home-link"
    [routerLink]="homeRoute()"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="sidebar__home-link--active"
  >
    <!-- <img class="sidebar__logo-img" height="36" src="./assets/images/png/logo.png" alt="App Logo" draggable="false" /> -->

    @let logoUrl = companyLogoUrl();
    @if (logoUrl) {
      <img
        class="logo logo--company"
        draggable="false"
        [src]="logoUrl"
        [alt]="'Логотип компании ' + (companyName() ?? '')"
        (error)="brokenLogoUrl.set(logoUrl)"
      />
    } @else {
      <svg-icon svgClass="logo" src="assets/images/svg/logo.svg"></svg-icon>
    }
    @if (!collapsed) {
      @let brandName = companyName() ?? '20-16-20.by';
      <span class="sidebar__logo-text" [title]="brandName">{{ brandName }}</span>
    }
  </a>
</div>

<ul
  nzMode="inline"
  nz-menu
  [nzInlineCollapsed]="collapsed"
  nzTheme="dark"
  class="sidebar__menu"
  [class.sidebar__menu--collapsed]="collapsed"
>
  @for (menuItem of menuItems; track $index) {
    @if (!menuItem.submenuItems) {
      <li
        nz-menu-item
        nzMatchRouter
        nz-tooltip
        *ngxPermissionsOnly="menuItem.permissions"
        nzTooltipPlacement="right"
        [nzTooltipTitle]="collapsed ? menuItem.title : ''"
        class="sidebar__menu-item"
      >
        <a class="sidebar__link" [routerLink]="menuItem.routerLink">
          <svg-icon [src]="menuItem.img" class="sidebar__icon"></svg-icon>
          @if (!collapsed) {
            <span class="sidebar__link-text">{{ menuItem.title }}</span>
          }
        </a>
      </li>
    } @else {
      <li
        *ngxPermissionsOnly="menuItem.permissions"
        nz-submenu
        [nzTitle]="titleTpl"
        class="sidebar__submenu"
        [class.sidebar__submenu--active]="activeSubmenuParents[menuItem.routerLink]"
      >
        <ul>
          @for (submenuItem of menuItem.submenuItems; track $index) {
            <li nzMatchRouter nz-menu-item class="sidebar__menu-item">
              <a class="sidebar__link" [routerLink]="submenuItem.routerLink">
                <span class="sidebar__link-text">{{ submenuItem.title }}</span>
              </a>
            </li>
          }
        </ul>
      </li>
      <ng-template #titleTpl>
        <svg-icon [src]="menuItem.img" class="sidebar__icon"></svg-icon>
        @if (!collapsed) {
          <a class="sidebar__link">
            <span class="sidebar__link-text">{{ menuItem.title }}</span>
          </a>
        }
      </ng-template>
    }
  }
</ul>
